
import React from "react";
import SidebarNavItem from "./SidebarNavItem";
import { NavItem } from "./types";

interface SidebarNavigationProps {
  navItems: NavItem[];
  isCollapsed: boolean;
  onItemClick?: () => void;
}

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({ navItems, isCollapsed, onItemClick }) => {
  return (
    <nav className="flex-1 overflow-y-auto py-6">
      <ul className="space-y-1 px-3">
        {navItems.map((item) => (
          <SidebarNavItem 
            key={item.path} 
            item={item} 
            isCollapsed={isCollapsed} 
            onClick={onItemClick}
          />
        ))}
      </ul>
    </nav>
  );
};

export default SidebarNavigation;
